/**
 * Centralized API URL configuration.
 *
 * The backend exposes two endpoint standards:
 * - **Legacy** endpoints live under `/api` (e.g. `/api/quickparts/…`)
 * - **New-standard** endpoints sit at the server root (e.g. `/tempus-tools/v3/…`)
 *
 * Import `API_BASE_URL` for legacy endpoints and `API_SERVER_URL` for new-standard ones.
 *
 * @module api-config
 */

/** Raw server origin (no path). Use for new-standard endpoints that don't need `/api`. */
export const API_SERVER_URL = import.meta.env.VITE_API_SERVER_URL

/** Server origin + `/api`. Use for legacy endpoints that require the `/api` prefix. */
export const API_BASE_URL = `${import.meta.env.VITE_API_SERVER_URL}/api`
